import {BackendError} from "@common-core/runtime-js/backend";
import {ClientEntity} from "@common-core/coat-operational-hierarchy-appsync-model";
import {TriggerResult} from "../../amplify/hooks/types";
import {LookupClientEntitiesByIdsData} from "./LookupClientEntitiesByIds";

export const assertClientEntitiesPresent = (
  result: TriggerResult<LookupClientEntitiesByIdsData>
): ClientEntity[] => {
  if (!result.data?.entities) {
    throw new BackendError(`Client Entities of "sources" not found`, 404);
  }
  return result.data.entities;
};
